export default {
    targetingParamLimit: 1,
    confidenceThreshold: 0.25,
};
